import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import { exportToExcel } from "react-json-to-excel";

const ExcelStaffList3 = (props) => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [selectedYear, setselectedYear] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");

  useEffect(() => {
    document.title = "Employee Staff List 3";

    setLoading(true);

    setselectedYear(props.year);
    setselectedMonth(props.Month);


    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Fyear: props.year,
      SelectedMonth: props.month,
      EmployeeTypeId: props.EmployeeTypeId,
      PayScale: props.PayScale,
      AccountLevel: props.Age || 0,
    };

    //console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetStaffList3",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);
    axios(api_config)
      .then(function (response) {
        let data = response.data.ListofRecords;
        const listOfEmployeeData = data.map((item, index) => {
          const dob = moment(item.SelectedEmployee?.Date_Of_Birth);
          const age = moment().diff(dob, "years");

          return {
            SrNo: index + 1,
            Code: item.SelectedEmployee?.Code,
            Staff_Name:
              age >= 55 ? `${item.SelectedEmployee?.Name} *` : item.SelectedEmployee?.Name,
            GPS: item.SelectedEmployee?.GPS_Scale,
            Basic_Salary: item.SelectedEmployee?.Basic_Salary,
            DOB: dob.isValid() ? dob.format(config.date_format) : "",
            DOJ: moment(item.SelectedEmployee?.Date_Of_Joining).format(config.date_format),
            Service_Duration: item.SelectedEmployee?.ServiceDuration,
            Retirement_Date: item.SelectedEmployee?.RetirementDate,
            Graduity: item.SelectedEmployee?.GraduityTotal,
          };
        });

        setLedger(listOfEmployeeData);
        setLoading(false);
      })
      .catch(function (error) {
        console.error(error);
        setLoading(false);
      });

  }, []);


  return (
    <>
      <button disabled={loading} className="button button-primary-outline excel-button" onClick={() => exportToExcel(listOfLedger, 'Manage Enquiry List')}>
        {loading ? <Spinner /> : <i className="ri-file-excel-2-line"></i>}
      </button>
    </>
  );
};

export default ExcelStaffList3;
